import { ConfigInterface, responseInterface } from 'swr';
import { wpApi, parseUrl, api, useApi } from '@gik/core/api';
import { Product } from '@gik/core/models/gik/Product';
import { ApiError } from 'next/dist/next-server/server/api-utils';
import { apiCap } from '..';

const path = 'users';

function getParams() {
  return {
    type: 'products',
    per_page: apiCap,
  };
}

export async function getSavedProducts(userId: string) {
  const finalUrl = parseUrl(`${path}/${userId}`, {
    searchParams: getParams(),
  });
  const ids = (await (await api.get(finalUrl)).json()) as string[];

  if (ids.length > 0) {
    const response = await wpApi.get(`products?include=${ids.join(',')}`);
    return await response.json();
  } else {
    return [];
  }
}

// TODO: this should fetch from a single endpoint so simplify revalidation
export function useSavedProducts<Data = Product[], Error = ApiError>(
  userId?: string,
  config?: ConfigInterface
): responseInterface<Data, Error> {
  const {
    data: ids,
    revalidate: revalidateFavorites,
    isValidating: isValidatingFavorites,
    mutate: mutateFavorites,
  } = useApi<string[]>(userId ? `${path}/${userId}/favorites` : null, config, {
    searchParams: getParams(),
  });

  const {
    data: products,
    revalidate: revalidateProducts,
    isValidating: isValidatingProducts,
    mutate: mutateProducts,
  } = useApi<Data, Error>(ids && ids.length > 0 ? `products` : null, config, {
    searchParams: {
      include: ids?.join(','),
    },
  });

  return {
    data: (ids?.length > 0 ? products : []) as Data,
    isValidating: isValidatingFavorites || isValidatingProducts,
    revalidate: async () => {
      const result1 = await revalidateFavorites();
      const result2 = await revalidateProducts();
      return result1 && result2;
    },
    mutate: async () => {
      await mutateFavorites(ids, true);
      const response = await mutateProducts(products, true);
      return response;
    },
  };
}
